export function formatDate(date, locale, options) {
    return Intl.DateTimeFormat(locale, options).format(date);
}
export function formatReviewCardDate(date) {
    return formatDate(new Date(date), undefined, {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
    });
}
